<template>
    <section>
        <chartBarras v-loading="loadingGrafica" :chart="chart_credito" />
    </section>
</template>

<script>
import Vue from 'vue'
import echarts from 'echarts'
import {mapGetters} from 'vuex'

Vue.component('echarts',echarts);
let bgColor = '#fff', fontColor = '#666';
let lineOption = {
    lineStyle: {
        color: 'rgba(151,151,151,0.5)',
        type: 'solid'
    }
}
let colorGeneral2 = getComputedStyle(document.documentElement) .getPropertyValue('--color-db')

export default {

    data(){
        return {
            loadingGrafica: false,
            chart_credito : {
                dataset: {
                    dimensions: ['key', 'value'],
                    source: []
                },
                backgroundColor: bgColor,
                tooltip:{
                    trigger: 'axis',
                    formatter: params => {
                        const data = params[0].data
                        // return  ` <div class="border-info text-center" style="border-radius: 30px; background-color: white; color: black;">
                        //             <span> ${data.dia} - ${this.separadorNumero(data.value)}</span>
                        //         </div> `
                        const color = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#03D6BC;"></span>`
                        return `${color} ${data.dia} - ${this.separadorNumero(data.value)}`
                    }
                },
                grid: {
                    top: '14%',
                    right: '3%',
                    left: '5%',
                    bottom: '14%'
                },
                xAxis: [{
                    type: 'category',
                    // name: '2 Ago. - 8 Ago.',
                    show: false,
                    nameTextStyle: {
                        color: '#6D6B6B',
                        align: 'right',
                        verticalAlign: "top",
                        lineHeight: 33
                    },
                    axisLine: lineOption,
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        margin: 10,
                        color: fontColor,
                        textStyle: {
                            fontSize: 14
                        },
                    },
                }],
                yAxis: [{
                    // name: '10 Feb. - 16 Feb.',
                    nameLocation: 'start',
                    nameTextStyle: {
                        color: '#6D6B6B',
                    },
                    axisLabel: {
                        formatter: '{value}',
                        color: fontColor,
                    },
                    axisTick: {
                        show: false
                    },
                    axisLine: lineOption,
                    splitLine: lineOption
                },{
                    axisLine: lineOption,
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show:false
                    }
                }],
                series: [{
                    type: 'bar',
                    // data: sData,
                    barWidth: '30px',
                    itemStyle: {
                        normal: {
                            color: colorGeneral2
                        }
                    }
                }]
            }
        }
    },
    computed:{
        ...mapGetters({
            graficaDosMeses: 'almacen/credito_tendero/graficaPorPagarMeses'
        }),
    },
    watch:{
        graficaDosMeses(val){
            if(val.length > 0){
                this.chart_credito.dataset.source = val
            }
        }
    },

    mounted(){
        this.recargarGrafica()
    },
    methods: {
        recargarGrafica(){
            if(this.graficaDosMeses.length > 0){
                this.chart_credito.dataset.source = this.graficaDosMeses
            }
        }

    }
}
</script>

<style lang="scss" scoped>

</style>
